module.exports = __webpack_public_path__ + "static/media/erasmo-baerga.ff742e5c.jpg";